import { render, staticRenderFns } from "./dossiers-overview-view.vue?vue&type=template&id=5177ff9d&scoped=true"
import script from "./dossiers-overview-view.vue?vue&type=script&lang=ts"
export * from "./dossiers-overview-view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5177ff9d",
  null
  
)

export default component.exports